import { usePlatformCopy } from '@/shared/platform/copy';
import { AgreeToTermsPolicy, SignInIdentifier } from '@logto/schemas';
import { useTranslation } from 'react-i18next';
import LandingPageLayout from '@/Layout/LandingPageLayout';
import SingleSignOnFormModeContextProvider from '@/Providers/SingleSignOnFormModeContextProvider';
import IdentifierRegisterForm from '@/components/IdentifierRegisterForm';
import TextLink from '@/components/TextLink';
import TermsAndPrivacyLinks from '@/containers/TermsAndPrivacyLinks';
import { useSieMethods } from '@/hooks/use-sie';
import useTerms from '@/hooks/use-terms';
import styles from './index.module.scss';

export default function Register() {
  const { t } = useTranslation();
  const copy = usePlatformCopy();
  const { signUpMethods } = useSieMethods();
  const { agreeToTermsPolicy } = useTerms();
  return (
    <LandingPageLayout title="description.create_your_account">
      <p className="platform-register-note">{signUpMethods.includes(SignInIdentifier.Email) ? copy.registerNote : copy.registerUsernameNote}</p>
      <SingleSignOnFormModeContextProvider>
        <IdentifierRegisterForm signUpMethods={signUpMethods} className={styles.main} />
        <div className={styles.createAccount}>
          {t('description.have_account')}{' '}
          <TextLink replace to="/sign-in" text="action.sign_in" />
        </div>
        {agreeToTermsPolicy === AgreeToTermsPolicy.Automatic && (
          <TermsAndPrivacyLinks className={styles.terms} />
        )}
      </SingleSignOnFormModeContextProvider>
    </LandingPageLayout>
  );
}
